import { jwtDecode } from 'jwt-decode'

export const isTokenExpired = (token: string) => {
  try {
    const decoded = jwtDecode<{ exp?: number }>(token)

    if (!decoded.exp) return true

    return Date.now() >= decoded.exp * 1000
  } catch {
    return true
  }
}
